import {Component, inject} from '@angular/core'
import {RouterLink, RouterOutlet} from '@angular/router'
import {MatToolbar} from '@angular/material/toolbar'
import {MatIcon} from '@angular/material/icon'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {ToggleButtonComponent} from './0-general/toggle-button/toggle-button.component'
import {MatDialog} from '@angular/material/dialog'
import {LicensesDialogComponent} from './0-general/licenses-dialog/licenses-dialog.component'
import version from '../../public/package.json'

@Component({
  selector: 'aku-root',
  imports: [RouterOutlet,
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatDrawerContainer,
    MatDrawer,
    MatDrawerContent,
    MatCard,
    MatCardContent,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    RouterLink,
    MatMenuItem,
    ToggleButtonComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  public version = version.version
  private readonly dialog = inject(MatDialog)
  public license() {
    this.dialog.open(LicensesDialogComponent)
  }
}
